import React, { useContext } from 'react';
import AccordionContext from '@context/AccordionContext';

type ContentProps = {
  children: JSX.Element;
};

export default function Content({ children }: ContentProps) {
  const { state } = useContext(AccordionContext);

  return <div className={state.isOpen ? 'block' : 'hidden'}>{children}</div>;
}
